import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as configApi from '../services/issueTypeFieldConfigService';
import type { SaveFieldConfigItem } from '../services/issueTypeFieldConfigService';

export const fieldConfigKeys = {
  all: ['issue-type-field-config'] as const,
  detail: (id: string) => ['issue-type-field-config', id] as const,
};

export function useFieldConfig(issueTypeId: string | undefined) {
  return useQuery({
    queryKey: fieldConfigKeys.detail(issueTypeId!),
    queryFn: () => configApi.fetchFieldConfig(issueTypeId!),
    enabled: !!issueTypeId,
    staleTime: 5 * 60 * 1000,   // 5분 — 자주 변경되지 않으므로
    gcTime: 30 * 60 * 1000,     // 30분
  });
}

export function useSaveFieldConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: { issueTypeId: string; configs: SaveFieldConfigItem[] }) =>
      configApi.saveFieldConfig(params.issueTypeId, params.configs),
    onSuccess: () => {
      // 모든 fieldConfig 캐시 무효화 (타입 간 필드 이동 가능하므로)
      qc.invalidateQueries({ queryKey: fieldConfigKeys.all });
    },
  });
}
